import { conversionRateBus } from '@/event/conversionRateBus'

export const convertPriceToEuro = (price: string | number) => {
  const priceNumber = typeof price === 'string' ? parseFloat(price) : price
  const convertedPrice = priceNumber * conversionRateBus.value

  return Number(convertedPrice).toFixed(2)
}
